import UserComponent from "../../modules/users/user";

export default function Campaigns() {
    return <UserComponent role="organization" />;
}